import { render, staticRenderFns } from "./ProfesorPolaznikManagment.vue?vue&type=template&id=750cae47&scoped=true&"
import script from "./ProfesorPolaznikManagment.vue?vue&type=script&lang=js&"
export * from "./ProfesorPolaznikManagment.vue?vue&type=script&lang=js&"
import style0 from "./ProfesorPolaznikManagment.vue?vue&type=style&index=0&id=750cae47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750cae47",
  null
  
)

export default component.exports